import { formatDateValue } from "@common";
import { dateTimeFormat } from "@pionglobal/pionsharedui";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const EMPTY_VALUE = "";

export const formatDateTime = (val) => {
  if (!val) return EMPTY_VALUE;
  try {
    const formatted = dateTimeFormat(val);
    if (formatted) return formatted;
  } catch {
    // fallback below
  }
  const parsed = dayjs(val);
  return parsed.isValid() ? parsed.format("DD-MMM-YYYY hh:mm A") : String(val);
};

const getValue = (value) => {
  if (value === null || value === undefined || value === "") return EMPTY_VALUE;
  if (typeof value === "object") {
    return (
      value?.userName ||
      value?.email ||
      value?.firstName ||
      value?.activityType ||
      value?.activityName ||
      value?.activityStatus ||
      value?.priorityType ||
      value?.priority ||
      value?.status ||
      value?.name ||
      EMPTY_VALUE
    );
  }
  return String(value);
};


export const getActivityView = (data = {}, projectUsersOptions = []) => {
  const userObj =
    typeof data?.assignedTo === "object"
      ? data?.assignedTo
      : projectUsersOptions.find(
        (u) =>
          u?.id === data?.assignedTo ||
          u?.id === data?.assignedToId ||
          u?.userId === data?.assignedTo ||
          u?.userId === data?.assignedToId ||
          u?.email === data?.assignedTo
      );

  const formattedUser =
    data?.assignedTo?.userName ||
    data?.assignedTo?.email ||
    data?.assignedTo?.firstName ||
    userObj?.userName ||
    userObj?.email ||
    userObj?.firstName ||
    (typeof data?.assignedTo === "string" ? data?.assignedTo : "") ||
    EMPTY_VALUE;

  const left = [
    {
      label: "Activity Type",
      value: getValue(data?.activityType),
    },
    {
      label: "Activity Name",
      value: getValue(data?.activityName),
    },
    {
      label: "Assigned To",
      value: getValue(formattedUser),
    },
    {
      label: "Due Date",
      value: formatDateTime(data?.dueDate),
    },
    {
      label: "Actual Date",
      value: formatDateTime(data?.actualDate),
    },
    {
      label: "Priority",
      value: getValue(data?.priority),
    },
    {
      label: "Status",
      value: getValue(data?.status),
    },
    {
      label: "Description",
      value: getValue(data?.description),
    },
    {
      label: "Outcome Note",
      value: getValue(data?.outComeNote),
    },
  ];

  const right = [

  ];

  const fullWidth = [

  ];

  return {
    left,
    right,
    fullWidth,
  };
};
